import { useEffect, useState, useCallback } from 'react';
import { ordersService } from '../services/orders';
import type { TrackingShipment } from '../types/orders';

export function useTracking(trackingNumber?: string) {
  const [data, setData] = useState<TrackingShipment | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTracking = useCallback(async () => {
    if (!trackingNumber) return;

    try {
      setLoading(true);
      setError(null);

      const res = await ordersService.getTrackingDetails(trackingNumber);

      if (res.success) {
        setData(res.shipment_manage);
      } else {
        setError(res.message);
      }
    } catch (err: any) {
      setError(err?.message || 'Failed to fetch tracking');
    } finally {
      setLoading(false);
    }
  }, [trackingNumber]);

  useEffect(() => {
    fetchTracking();
  }, [fetchTracking]);

  return { data, loading, error, refetch: fetchTracking };
}